import React from 'react';
import PropTypes from 'prop-types';

import translate from '../../_utils/tools/translate';

export default function InvalidPostalCodeWarning({ id, className }) {
  return (
    <div
      className={`invalid-postal-code-warning ${className}`}
      id={id}
      data-test-id="invalid-zip-code-warning"
      role="alert">
      <small className="text-danger">
        Please enter a valid {translate('zip code')}.
      </small>
    </div>
  );
}

InvalidPostalCodeWarning.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

InvalidPostalCodeWarning.defaultProps = {
  id: 'invalid-zip-code-warning',
};
